var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {},
    [
      _c("SearchableDocumentsList", {
        attrs: {
          query: _vm.query,
          projectId: _vm.project.id,
          currentUser: _vm.currentUser,
        },
        scopedSlots: _vm._u([
          {
            key: "emptyListActions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end pt-3 pb-5",
                  attrs: {
                    attachedToUserId: _vm.contractorUserId,
                    companyId: _vm.companyId,
                    currentUserId: _vm.currentUser.id,
                    currentUserParent: _vm.currentUser,
                    buttonSize: "xl",
                    buttonLabel: "Upload document",
                    variant: "blueBlack",
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }